import axios from 'axios';

export const fetchClientList = async () => {
  const res = await axios.get(
    `${RailsRoutes.api_v2_people_path()}?include=currentCards,accounts,latestFundsTransfers`,
  );

  return res.data.data.map((client) => {
    const clientSlug = client.relationships.accounts.data?.[0]?.id;
    const account = res.data.included.find(
      (included) => included.type === 'account' && included.id === clientSlug,
    );

    const latestTransferData = client.relationships.latestFundsTransfers.data;
    const lastTransferId = latestTransferData?.[latestTransferData.length - 1]?.id;

    const transfer = res.data.included.find(
      (included) => included.type === 'transfer' && included.id === lastTransferId,
    )?.attributes;

    const card = res.data.included.find(
      (included) =>
        included.type === 'card' && included.id === account.relationships.currentCard?.data.id,
    );

    const isReissue = card?.relationships?.cardReissues?.data?.length > 0;

    const getCardStatus = () => {
      const status = card?.attributes?.status;
      if (card?.isBreached && status === 'OPEN' && !isReissue) {
        return 'COMPROMISED_ACTION_NEEDED';
      }
      if (card?.isBreached) {
        return 'COMPROMISED';
      }
      return status;
    };

    return {
      id: client.id,
      nickname: client.attributes.nickname,
      firstName: client.attributes.firstName,
      lastName: client.attributes.lastName,
      slug: clientSlug,
      cardStatus: getCardStatus(),
      cardBalance: card?.attributes?.balance?.amount || 0,
      cardFraudBlockType: card?.attributes?.fraudBlockType,
      transferAmount: transfer?.amount?.amount,
      transferDate: transfer?.date,
      statementDate: account?.attributes?.latestStatementDate,
      bulkCardOrder: account?.attributes?.bulkCardOrder,
      isReissue,
      programType: account?.attributes?.programType,
    };
  });
};
